var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"errorBox"},[_c('svg-icon',{staticClass:"errorIcon",attrs:{"iconClass":"error"}}),_vm._v(" 该页面还未开放 "),_c('div',{staticClass:"backBtn",on:{"click":_vm.goBack}},[_vm._v("返回上一页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }